// 质检系统
export default [
    {
        path: '/qualityResults',
        name: 'qualityResults',
        component: () => import('@views/quality-testing/quality-results/qualityResults'),
        meta: { title: '质检结果', keepAlive: true }
    },
    // 质检结果-查看
    {
        path: '/qualityInspectionView/:type/:id',
        name: 'qualityInspectionView',
        props: true,
        component: () => import('@/views/quality-testing/quality-results/BaseView.vue'),
        meta: { title: '质检结果查看', keepAlive: true }
    },
    // {
    //     path: '/qualityTestingEdit/:type/:id',
    //     name: 'qualityTestingEdit',
    //     props: true,
    //     component: () => import('@/views/quality-testing/quality-results/qualityTestingEdit.vue'),
    //     meta: { title: '质检', keepAlive: true }
    // },
    {
        path: '/appealTestingEdit/:type/:id',
        name: 'appealTestingEdit',
        props: true,
        component: () => import('@/views/quality-testing/quality-results/appealTestingEdit.vue'),
        meta: { title: '申诉', keepAlive: true }
    },
    {
        path: '/performanceStatistics',
        name: 'performanceStatistics',
        component: () => import('@views/quality-testing/reportForms/performanceStatistics'),
        meta: { title: '质检报表', keepAlive: true }
    }
]
